module.exports = __webpack_public_path__ + "img/esc_5_act_3.550c446b.png";